import { Injectable } from '@angular/core';
import { Http, Headers, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { Subject } from 'rxjs/Subject';
import { ManageReleaseRequest } from '../models/update-release-request';
import { AuthHttp } from 'angular2-jwt';
import { EnvironmentsService } from 'app/services/enviornment.service';
import { AuthorizedActions, UserAuthorizationRoleReq } from 'app/models/use-auth-role-req';
import { VMwareProducts } from 'app/models/vmwareproducts';
import { ManageRoles } from 'app/models/manageroles';


@Injectable()
export class AdminService {

    private subject = new Subject<any>();

    constructor(private authhttp: AuthHttp, private envService: EnvironmentsService) {
    }

    updateRelease(releaseReq: ManageReleaseRequest): Observable<any> {
        let headers = new Headers();
        headers.append('Content-Type', 'application/json');
        const requestOptions = {
            headers: headers,
            withCredentials: true,
        };
        return this.authhttp.put(this.envService.config.espApi +
            "admin/v1/vmwareproducts/" + releaseReq.productId + "/releases/" + releaseReq.releaseId, releaseReq, requestOptions)
            .map((response: Response) => {
                let resp = response.json();
                return resp;
            });
    }

    addRelease(releaseReq: ManageReleaseRequest): Observable<any> {
        let headers = new Headers();
        headers.append('Content-Type', 'application/json');
        const requestOptions = {
            headers: headers,
            withCredentials: true,
        };
        return this.authhttp.post(this.envService.config.espApi +
            "admin/v1/vmwareproducts/" + releaseReq.productId + "/releases/", releaseReq, requestOptions)
            .map((response: Response) => {
                let resp = response.json();
                return resp;
            });
    }

    deleteRelease(productId: number, releaseId: number): Observable<any> {
        let headers = new Headers();
        headers.append('Content-Type', 'application/json');
        const requestOptions = {
            headers: headers,
            withCredentials: true,
        };
        return this.authhttp.delete(this.envService.config.espApi +
            "admin/v1/vmwareproducts/" + productId + "/releases/" + releaseId, requestOptions)
            .map((response: Response) => {
                let resp = response.json();
                return resp;
            });
    }

    getRMReleasesNotInConfigMax(productId: number, date: string): Observable<any> {
        return this.authhttp.get(this.envService.config.espApi +
            "limits/menutree/v1/releasemanager/vmwareproducts/" + productId + "/gadate/" + date, { withCredentials: true })
            .map((response: Response) => {
                let resp = response.json();
                return resp;
            });
    }
    getRolesForProduct(productId: string): Observable<any> {
        return this.authhttp.get(this.envService.config.espApi +
            "admin/v1/auth/vmwareproducts/"+productId+"/roles", { withCredentials: true })
            .map((response: Response) => {
                let resp = response.json();
                return resp;
            });
    }
    addUserAuthorizationRole(roleReq: UserAuthorizationRoleReq, action: AuthorizedActions): Observable<any> {
        let headers = new Headers();
        headers.append('Content-Type', 'application/json');
        const requestOptions = {
            headers: headers,
            withCredentials: true,
        };
        return this.authhttp.post(this.envService.config.espApi +
            "admin/v1/auth/role/user/"+action, roleReq, requestOptions)
            .map((response: Response) => {
                return response;
            });
    }

    manageRoles(createRoleReq: ManageRoles): Observable<any> {
        let headers = new Headers();
        headers.append('Content-Type', 'application/json');
        const requestOptions = {
            headers: headers,
            withCredentials: true,
        };
        return this.authhttp.post(this.envService.config.espApi +
            "admin/v1/auth/role", createRoleReq, requestOptions)
            .map((response: Response) => {
                return response;
            });
    }

    addProducts(productReq: VMwareProducts): Observable<any> {
        let headers = new Headers();
        headers.append('Content-Type', 'application/json');
        const requestOptions = {
            headers: headers,
            withCredentials: true,
        };
        return this.authhttp.post(this.envService.config.espApi +
            "admin/v1/auth/product", productReq, requestOptions)
            .map((response: Response) => {
                return response;
            });
    }
    getAuthorizedUsers(): Observable<any> {
        // Headers are now automatically added by the HTTP interceptor
        // Just pass withCredentials option
        const requestOptions = {
            withCredentials: true,
        };
        return this.authhttp.get(this.envService.config.espApi +
            "admin/v1/auth/users", requestOptions)
            .map((response: Response) => {
                let resp = response.json();
                return resp;
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/admin/admin.service.ts